import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { HisNotificationService, HisAuthService, HisUiService, HisJobStatus } from 'hisng';
import { OrcidImportService } from '../../../service/orcid-import.service';
import { ImportRun } from '../../../model/import-run';
import { PublicationSearchOrcidUserFormComponent } from './publication-search-orcid-user-form.component';
import { INTERFACE_TYPE_ORCID } from '../../../model/constants';
import { PublicationImportService } from '../../../service/publication-import.service';

@Component({
    selector: 'res-publication-orcid-import',
    templateUrl: './publication-orcid-import.component.html'
})
export class PublicationOrcidImportComponent implements OnInit {
    @ViewChild(PublicationSearchOrcidUserFormComponent, { static: false }) searchFormComponent: PublicationSearchOrcidUserFormComponent;
    @Output() searchResultsAreDisplayed = new EventEmitter<boolean>();

    // TODO Hinweis 'es sind keine IDs hinterlegt', wenn Liste leer
    public myOrcidIds: string[] = [];
    public myOrcidIdsFiltered: string[] = [];
    public importRun: ImportRun;
    public importMyOrcid = false;
    public importOrcidFromOtherPersons = false;
    public displaySearchForm = true;
    public displaySearchResults = false;
    public search: any;

    constructor(public hisAuthService: HisAuthService,
        private hisUiService: HisUiService,
        private changeDetectorRef: ChangeDetectorRef,
        private orcidImportService: OrcidImportService,
        private publicationImportService: PublicationImportService,
        private notificationService: HisNotificationService) {
    }

    ngOnInit() {
        this.importMyOrcid = this.canImportOwnOrcid();
        this.importOrcidFromOtherPersons = this.canImportForeignOrcid();

        this.importRun = new ImportRun();

        if (this.importMyOrcid) {
            this.orcidImportService.myOrcidIds().subscribe( (ids: string[]) => {
                this.myOrcidIds = ids;
                this.myOrcidIdsFiltered = ids;
                if (ids?.length === 1) {
                    this.importRun.importSource = ids[0];
                }
            });
        }
    }

    private canImportOwnOrcid(): boolean {
        if(this.hisAuthService.hasAll('RIGHT_FS_RES_PUBLICATION_IMPORT_PUBLICATION_OWN')) {
            let rightsparametervalue = this.hisAuthService.getRightsParameterValue(
                'RIGHT_FS_RES_PUBLICATION_IMPORT_PUBLICATION_OWN', 'fs.res.publication.import');
            return rightsparametervalue.includes('orcid');
        }
        return false;
    }

    private canImportForeignOrcid(): boolean {
        if(this.hisAuthService.hasAll('RIGHT_FS_RES_PUBLICATION_IMPORT_PUBLICATION')) {
            let rightsparametervalue = this.hisAuthService.getRightsParameterValue(
                'RIGHT_FS_RES_PUBLICATION_IMPORT_PUBLICATION', 'fs.res.publication.import');
            return rightsparametervalue.includes('orcid');
        }
        return false;
    }

    public doImport(selectionOfFormResults?: any) {
        if (!this.importOrcidFromOtherPersons && this.importMyOrcid) {
            if (this.importRun.importSource) {
                this.publicationImportService.startImport(INTERFACE_TYPE_ORCID, {orcidIds: this.importRun.importSource} ).subscribe(() => {
                    this.notificationService.successI18n('fs.res.publication.import.orcid.success', this.importRun.importSource);
                } );
            }
        }
        if (this.importOrcidFromOtherPersons && selectionOfFormResults) {
            const orcidIds: string[] = this.getOrcidsToImport(selectionOfFormResults);

            this.publicationImportService.startImport(INTERFACE_TYPE_ORCID, {orcidIds: orcidIds.join(', ')}).subscribe(
                () => {
                    console.log('The import job has been started successfully.');
                    // XXX can we unify this with the existing convenience methods?
                    this.notificationService.success(
                        this.hisUiService.translate('fs.res.publication.import.fromOrcidApi.started'),
                        this.hisUiService.translate('messagebox.singleSuccessTitle')
                    );
                },
                (error: any) => console.log(error)
            );
        }
    }

    /**
     * get selected ORCIDs, if none was selected return all
     */
    private getOrcidsToImport(selectionOfFormResults: any): string[] {
        const orcidIds: string[] = [];
        if(selectionOfFormResults.selectedOptions.length > 0) {
            selectionOfFormResults.selectedOptions.forEach((row: any) => {
                orcidIds.push( row['[Identifier].identifier']);
            });
        } else {
            selectionOfFormResults.allResults.forEach((row: any) => {
                orcidIds.push(row.values[3]);
            });
        }
        return orcidIds;
    }

    public displaySearch(resetInputFields: boolean) {
        this.displaySearchForm = true;
        this.displaySearchResults = false;
        this.searchResultsAreDisplayed.emit(false);
        if (resetInputFields) {
            this.searchFormComponent.resetInputs();
        }
    }

    public displayResults(search: any) {
        this.search = search;
        this.displaySearchForm = false;
        this.displaySearchResults = true;
        this.changeDetectorRef.detectChanges();
        this.searchResultsAreDisplayed.emit(true);
    }

    public filterSuggestions(event: { query: string }) {
        this.myOrcidIdsFiltered = this.myOrcidIds.filter(
            item => event.query === '' || item.toLowerCase().indexOf(event.query.toLowerCase()) !== -1
        );
    }
}
